export default __webpack_public_path__ + "static/media/benefit_3@3x.bdc764b7.png";